import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import ConfigurationContainer from "components/ConfigurationContainer";
import theme from "../../theme/theme";
import useStyles from "./styles";

const Configuration = () => {
  const [selectedTheme, setSelectedTheme] = useState(
    JSON.parse(localStorage.getItem("theme")!)
  );

  const [appTheme, setAppTheme] = useState(theme?.defaultTheme);
  const { rootContainer } = useStyles(appTheme);

  useEffect(() => {
    switch (selectedTheme) {
      case "red":
        setAppTheme(theme?.redTheme);
        break;
      case "green":
        setAppTheme(theme?.greenTheme);
        break;
      case "yellow":
        setAppTheme(theme?.yellowTheme);
        break;
      case "default":
        setAppTheme(theme?.defaultTheme);
        break;
      default:
        setAppTheme(theme?.defaultTheme);
        break;
    }
  }, [selectedTheme]);

  return (
    <>
      <Grid container className={rootContainer}>
        <Grid item xs={12}>
          <ConfigurationContainer />
        </Grid>
      </Grid>
    </>
  );
};
export default Configuration;
